<template>
    <div  v-if="showLayout">
        <div class="c_table_wrap">
            <table>
                <colgroup>
                    <col width="200px;">
                    <col width="">
                    <col width="200px;">
                    <col width="">
                    <col width="200px;">
                    <col width="">
                </colgroup>
                <tr>
                    <td class="c_t_title">총 주문 금액</td>
                    <td>
                        <div class="d_block">
                            {{ returnCommas(orderData.orderAllPrice) }}
                        </div>
                    </td>
                    <td class="c_t_title">해당 상품 주문 금액</td>
                    <td>
                        <div class="d_block">
                            {{ returnCommas(orderData.orderCartPrice) }}
                        </div>
                    </td>
                    <td class="c_t_title">해당 주문 건 배송비</td>
                    <td>
                        <div class="d_block">
                            {{ returnCommas(orderData.orderSendPrice) }}
                        </div>
                    </td>
                </tr>
            </table>
        </div>
        <order-list-component :defaultParams="{oid: orderData.orderNumber}" :orderType="'modalOrderGroupList'"></order-list-component>
    </div>

</template>

<script>
import util from "@/mixins/util";
import EventBus from "@/mixins/event-bus";
import alertMixins from "@/mixins/alertMixins";
import Order from "@/components/order/order"
import numberMixins from "@/mixins/NumberMixins";
import {mapState} from "vuex";
import OrderListComponent from "@/components/order/OrderListComponent.vue";

export default {
    name: "OrderModalInformationComponent",
    mixins: [numberMixins],
    components: {
        OrderListComponent
    },
    inject: [],
    provide() {
        return{
            isCheckMove: this.isCheckMove,
            moveDetailAfterFunc: this.moveDetailAfterFunc,
        }
    },
    props: {
        orderKey:{default:0},
        modalName: {default: ''},
    },
    data() {
        return{
            orderClass:null,
            showLayout:false,
            orderData:{},

        }
    },
    beforeRouterEnter() {},
    created() {
        this.orderClass = new Order.OrderClass(this.UserInfo)
        if(this.orderKey == 0){
            return false
        }
        this.getOrder();
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {},
    computed: {
        ...mapState({
            UserInfo: state => state.userInfo.UserInfo
        })
    },
    methods:{
        loadLayout() {
            this.showLayout = true;
        },
        getOrder(){
            EventBus.$emit('changeLoading', true);
            let params = {
                type : 'basic',
                f :1,
                //st :[10],
                ip : 0,
                or : 1, // 주문정보
                oa : 1, // 배송정보
                ba : 1, // 입금정보
                id :this.orderKey,
            }
            try {
                this.$api.$order.getOrder(params).then(res => res.Data.Result).then(res => {
                    EventBus.$emit('changeLoading', false );
                    if(!util.isEmpty(res.List) && res.Info.Type == 1) {
                        this.orderData = this.orderClass.getOrderInfoData(res.List[0])
                        this.loadLayout();
                    }else {
                        this.errorAlert('데이터를 불러오지 못했습니다.')
                    }
                })
            }catch (e) {
                console.log(e)
            }
        },
        isCheckMove(row) {
            return row.c_idx != this.orderKey;
        },
        moveDetailAfterFunc() {
            if(this.modalName != '') {
                this.$modal.hide(this.modalName)
            }

        },
    },
    watch: {

    },
}
</script>

<style scoped>

</style>
